import { RestrictionMessage } from '../../../component';
import Constants from '../../../constants';
import DefaultContainer from '../../../container/default_container';
import { MatchTabCricket, MatchTabYesNo, MatchTabFootball } from '../../../fantasy_games';
import './index.css';

const FantasyHomeWeb = ({ gameType, currentLocationState, isBanned }: any) => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="fantasy_home_wrapper">
        {/* <View
          style={{
            flexGrow: 1,
            position: 'relative'
          }}> */}
        {isBanned ? (
          <RestrictionMessage stateName={currentLocationState} />
        ) : (
          <>
            {gameType === Constants.GameType.FANTASY_CRICKET && (
              <MatchTabCricket gameType={Constants.GameType.FANTASY_CRICKET} />
            )}

            {gameType === Constants.GameType.FANTASY_YES_NO && (
              <MatchTabYesNo gameType={Constants.GameType.FANTASY_YES_NO} />
            )}
            {gameType === Constants.GameType.FANTASY_FOOTBALL && (
              <MatchTabFootball gameType={Constants.GameType.FANTASY_FOOTBALL} />
            )}
          </>
        )}
        {/* </View> */}
      </div>
    </DefaultContainer>
  );
};
export default FantasyHomeWeb;
